export default __webpack_public_path__ + "static/media/elevate-gry-banner-3.b2e8c4ae.jpg";